import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { SortableContainer } from 'react-sortable-hoc'
import { IMediaType } from '../../types/mediaType'
import { updateMediaType } from '../../actions/mediaType'
import { updateMediaTypes } from '../../actions/mediaTypes'
import { selectMediaTypesSortedByPriority } from '../../selectors/mediaTypes'
import { calculatePriority } from '../../services/sort'
import { PrioritiesTableBody, PrioritiesTableHead } from './PrioritiesTable/'
import { StyledPrioritiesTable } from './PrioritiesTable/styled'

export interface IPrioritiesTab {
  list: IMediaType[]
  dispatch: Dispatch
}

const PrioritiesTabComponent = ({ list, dispatch }: IPrioritiesTab) => {
  const SortableList = SortableContainer(PrioritiesTableBody)
  const onSortEnd = ({ oldIndex, newIndex }): void => {
    if (oldIndex !== newIndex) {
      const newPriority = calculatePriority(list, oldIndex, newIndex)
      dispatch(
        updateMediaTypes(
          list.map((item, index) =>
            index === oldIndex ? { ...item, priority: newPriority } : item
          )
        )
      )
      dispatch(updateMediaType({ ...list[oldIndex], priority: newPriority }))
    }
  }

  return (
    <StyledPrioritiesTable>
      <PrioritiesTableHead />
      <SortableList
        list={list}
        onSortEnd={onSortEnd}
        helperClass="media-type-list-sorted-item"
        useDragHandle
      />
    </StyledPrioritiesTable>
  )
}

export const PrioritiesTab = connect(selectMediaTypesSortedByPriority)(
  PrioritiesTabComponent
)
